module.exports = __webpack_public_path__ + "img/evaluate-navbar-icon.71beb0e4.svg";